<template>
  <v-page page="serviceVersions">
    <v-card max-width="50%" class="elevation-2">
      <v-img
        src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
        max-height="220px"
        ></v-img>
      <v-card-title>
        <h2>Game Client service version</h2>
      </v-card-title>
      <p class="text--darken-2 pl-3">current default version: <strong>{{ currentActiveDefaultVersion.version }} # {{ currentActiveDefaultVersion.image_tag }}</strong></p>
      <v-card-actions>
        <v-btn
          color="orange lighten-2"
          left
          text
          @click="showSetDefaultVersionRadios = !showSetDefaultVersionRadios"
          >
          <v-icon>{{ showSetDefaultVersionRadios ? 'arrow_drop_down' : 'arrow_right' }}</v-icon>
          Set global default active version
        </v-btn>
      </v-card-actions>
      <v-expand-transition>
        <div v-show="showSetDefaultVersionRadios === true">
          <v-container fluid grid-list-lg>
            <h2>Set global default Game Client service version</h2>
            <span>This sets the default version of the McKinsey Problem Solving Game for <strong>all</strong> assessments</span>
            <v-layout row wrap>
              <v-container class="px-6" fluid>
                <v-radio-group v-model="currentActiveDefaultVersion.id" column>
                  <v-radio
                    v-for="(item, idx) in serviceVersionsItems"
                    :key="idx"
                    :color="item.is_default ? 'green' : 'orange'"
                    :value="item"
                  >
                  <template v-slot:label>
                    <span :class="item.is_default ? 'green--text text--darken-4': ''">v{{ item.version }} # {{ item.image_tag }}</span>
                    <span v-if="item.is_default">
                      <v-icon left>arrow_left</v-icon>
                      Current active default version
                    </span>
                  </template>
                  </v-radio>
                </v-radio-group>
              </v-container>
            </v-layout>
            <v-btn color="success darken-2"
                @click="setDefaultServiceVersion"
                class="pl-1"
                data-test="setDefaultServiceVersion">
              <v-icon class="px-0" left></v-icon>
              Set Default
            </v-btn>
          </v-container>
        </div>
      </v-expand-transition>
    </v-card>
    </v-page>
</template>
<script>
import sortBy from 'lodash.sortby'
import reverse from 'lodash.reverse'
import VPage from '@/layouts/Default'
import { mapState } from 'vuex'

export default {
  mounted () {
    this.$store.dispatch('clientServiceVersions/getServiceVersions', 'game-ui')
  },
  computed: {
    ...mapState({
      // sort descending by service_version id only last 8
      serviceVersionsItems: (state) => reverse(sortBy(state.clientServiceVersions.serviceVersions, [function (sv) { return sv.id }])).slice(0, 8),
      // highlight the current active version and watch if we change it
      currentActiveDefaultVersion (state) {
        if (Object.values(state.clientServiceVersions.serviceVersions).length > 0) {
          return Object.values(state.clientServiceVersions.serviceVersions).filter(item => item.is_default && item.is_active)[0]
        }
      }
    })
  },
  data () {
    return {
      defaultServiceVersion: 1,
      showSetDefaultVersionRadios: false
    }
  },
  methods: {
    setDefaultServiceVersion () {
      var serviceDict = {
        'service_name': 'game-ui',
        'service_version': this.currentActiveDefaultVersion.id
      }
      this.$store.dispatch('clientServiceVersions/setDefaultServiceVersions', serviceDict)
    }
  },
  components: {
    VPage
  }
}
</script>
